/* eslint-disable import/no-extraneous-dependencies */
import { ActionType, createAction } from 'typesafe-actions';

export enum confirmationModalActionTypes {
  Open = '[confirmationModal] Open',
  Close = '[confirmationModal] Close',
}

export const confirmationModalActions = {
  open: createAction(confirmationModalActionTypes.Open)(),
  close: createAction(confirmationModalActionTypes.Close)(),
};

export type confirmationModalAction = ActionType<typeof confirmationModalActions>;
